// extracted by mini-css-extract-plugin
export default {"error":"styles_error__U9YN7","errorText":"styles_errorText__eR+tJ","spin":"styles_spin__fRDDV"};